import React, {Component} from "react";
import _ from "lodash";
import CdmLayout from "./../../templates/cdm";
import status from "./../json/status";
//import profiles from "./../json/profiles";
import current_tasks from "./../json/current_tasks";
import TaskCard from "../elements/widgets/task-card";
import TaskNavigation from "./../elements/widgets/task-navigation";

class CdmHome extends Component {
    render() {
        return (<div className="columns is-multiline">
	        <div className="column is-10 is-offset-1">
		        <TaskNavigation setFilters={this.setFilters} statusList={status.data} selected={this.state.filters.status} />
	        </div>
	        <div className="column is-10 is-offset-1">
		        <div className="task-cards columns is-multiline">
			        {_.map(current_tasks.data, (task, key) => {
				        return <TaskCard filter={this.state.filters.status}
		                          category={this.state.category}
		                          statusList={status.data} key={key}
		                          {...task}
				                />
		                })
			        }
		        </div>
	        </div>
        </div>)
    }

    constructor() {
    	super();
    	this.state = {
    		filters: {
			    status: undefined,
			    category: undefined
		    }
	    }
	    this.setFilters = this.setFilters.bind(this);
    }

    setFilters = (filter) =>  {
    	return this.setState({
		   filters: {
			   ...this.state.filters,
		   	    status: filter === this.state.filters.status ? undefined : filter
		   }
	    });
    }
}

export default CdmLayout(CdmHome, {
	title: 'Dashboard',
    subnav: {
        icon: 'fa-briefcase',
        name: 'Mis Tareas',
        actions: [
        ]
    },
    stateNav: true,
    progress: true
});


// WEBPACK FOOTER //
// ./src/cdm-frontend/pages/index.jsx